import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'qt-data-table-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class DataTableLoadingComponent {
  @Input() size: 'sm' | 'md' | 'lg' = 'md';

  getSizeStyle() {
    switch (this.size) {
      case 'sm':
        return '1.5rem';
      case 'md':
        return '3rem';
      case 'lg':
        return '5rem';
    }
  }
}
